/**
 * @generated SignedSource<<4457a7ce1b37b60bd16542e6e54badaa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ColumnConfigWithContainer$data = {
  readonly __id: string;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly displayName: string;
      readonly fieldSetId: string;
      readonly fieldType: {
        readonly displayName: string | null | undefined;
      } | null | undefined;
      readonly type: string;
    };
  } | null | undefined>;
  readonly totalCount: number;
  readonly " $fragmentType": "ColumnConfigWithContainer";
};
export type ColumnConfigWithContainer$key = {
  readonly " $data"?: ColumnConfigWithContainer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ColumnConfigWithContainer",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "totalCount"
      },
      "action": "THROW",
      "path": "totalCount"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssueSearchFieldSetEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueSearchFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "fieldSetId"
                  },
                  "action": "THROW",
                  "path": "edges.node.fieldSetId"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  "action": "THROW",
                  "path": "edges.node.type"
                },
                {
                  "kind": "RequiredField",
                  "field": (v0/*: any*/),
                  "action": "THROW",
                  "path": "edges.node.displayName"
                },
                {
                  "concreteType": "JiraFieldType",
                  "kind": "LinkedField",
                  "name": "fieldType",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "edges.node"
          }
        ]
      },
      "action": "THROW",
      "path": "edges"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchFieldSetConnection"
};
})();

(node as any).hash = "3ae1385f88e17b8e9d2dda509c942a08";

export default node;
